import { FieldProps, getIn } from 'formik';
import { useIntl } from 'react-intl';
import Checkbox, { CheckboxProps } from '../atoms/Checkbox';
import ErrorMessage from '../atoms/ErrorMessage';

type CheckboxFieldProps = FieldProps & CheckboxProps & { errorName: string; 'data-test-id': string };

const CheckboxField = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  meta,
  ...props
}: CheckboxFieldProps) => {
  const isTouched = getIn(touched, field.name);
  const error = isTouched && getIn(errors, field.name);
  const { formatMessage } = useIntl();
  const { 'data-test-id': dataTestId } = props;

  return (
    <>
      <Checkbox
        {...props}
        {...field}
        onChange={value => {
          props.onChange?.(value);
          setFieldValue(field.name, value);
          setTimeout(() => setFieldTouched(field.name), 0);
        }}
        dataTestId={dataTestId}
      />
      <ErrorMessage label={formatMessage({ id: 'errors.checkboxLabel' })} error={error} dataTestId={dataTestId} />
    </>
  );
};

export default CheckboxField;
